import axios from "./configure";

export default {
    getSession: params => axios.get("/identify/session", { params }),
    getSurveyFrom: params => axios.get("message/survey", { params }),
    insertSurvey: data => axios.post("/message/survey/reply", data),
    updateSurvey: data => axios.put("/message/survey/reply", data),
    identifySend: data => axios.post("/identify/send", data),
    identifyCheck: data => axios.post("/identify/check/external", data),
    getSchoolInfo: id => axios.get(`/reservation/users/school/${id}`),
    getAppSchoolList: params => axios.get('reservation/users/schools', { params }),
    sendSmsAuth: data => axios.get('/identify/send', data),
    createReservation: data => axios.post("reservation/users/reservations", data),
    getReservations: params => axios.get(`reservation/users/reservations`, {params}),
    getReservation: (params, id) => axios.get(`reservation/users/reservations/${id}`, {params}),
    cancelReservation: (data, id) => axios.post(`reservation/users/reservations/${id}/cancel`, data),
    getTeacherAppReservation: (params, id) => axios.get(`reservation/teachers/reservations/${id}`, {params}),
    teacherAppReservationAllow: (params, id) => axios.post(`reservation/teachers/reservations/${id}/allow`, null, {params}),
    teacherAppReservationDeny: (params, id) => axios.post(`reservation/teachers/reservations/${id}/deny`, null, {params}),

    fileUpload: data =>
        axios.post("https://file.school-mom.kr/uploadFile.php", data, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
};
